import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-ul',
  templateUrl: './ul.component.html',
  styleUrls: ['./ul.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UlComponent {}
